











import { Component, Prop, Vue } from 'vue-property-decorator';
// import Contact from '@/components/ContactUs.vue';
// import { HOST } from '@/global';
@Component({
  name: 'ContactPage',
  components: {}
})
export default class ContactPage extends Vue {
  // @Prop() private msg!: string;
  // @Prop() pageData: any;
  // HOST: string = HOST;
}
